/**
 * Service pour les opérations sur les appels
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const callsService = {
  create: (data) => api.post(endpoints.calls.create(), data),
  // Mise à jour d'un appel déjà enregistré : sert quand la conversation se
  // poursuit après la validation de l'analyse du besoin (durée finale), et
  // quand le commercial revient corriger son analyse — dans les deux cas il
  // s'agit du MÊME échange, pas d'un second appel.
  update: (id, data) => api.put(endpoints.calls.update(id), data)
}
